export default __webpack_public_path__ + "static/media/logoWhite.e503f493.png";